import React, { useMemo } from 'react';
import { Image } from 'antd';
import cx from './index.module.scss';

type PreviewGroupType = typeof Image.PreviewGroup.defaultProps;

type Source = 'servicing' | 'no-servicing';
interface Props extends PreviewGroupType {
  beforeImgList: string[];
  afterImgList: string[];
  previewIndex: number;
  updatePreviewIndex: (index: number) => void;
  isNeedImgGroup?: boolean;
  // 图片对比长度
  totalCompareLength?: number;
  noBeforeUploadText?: string;
  noAfterUploadText?: string;
  source?: Source;
}

export const ImagePreviewCompare = ({
  beforeImgList,
  afterImgList,
  previewIndex,
  updatePreviewIndex,
  isNeedImgGroup = true,
  totalCompareLength = 4,
  noBeforeUploadText = null,
  noAfterUploadText = null,
  source = 'servicing',
  ...props
}: Props) => {
  const previewImgList = useMemo(() => {
    //Note 以数量低的为基准去除掉多余的文字评价项（多余出的数组项是用户评价）
    const trimmedBeforeImgList = beforeImgList.slice(0, totalCompareLength);
    const trimmedAfterImgList = afterImgList.slice(0, totalCompareLength);

    return trimmedBeforeImgList.map((item, index) => {
      const afterSrc = trimmedAfterImgList[index];
      const beforeSrc = trimmedBeforeImgList[index];

      return JSON.stringify({ afterSrc, beforeSrc });
    });
  }, [beforeImgList, totalCompareLength, afterImgList]);

  return isNeedImgGroup ? (
    <Image.PreviewGroup
      items={previewImgList}
      preview={{
        forceRender: true,
        current: previewIndex,
        styles: {
          mask: {
            backgroundColor: `rgba(255, 255, 255, 0.20)`,
            backdropFilter: 'blur(30px)',
          },
        },
        toolbarRender: () => <></>,
        // getContainer: () => imagePreviewContainer.current,
        // 解析src中的JSON，自行渲染对比图
        onChange: index => {
          updatePreviewIndex(index);
        },
        imageRender: (originalNode, info) => {
          let previewImgObj: { afterSrc: string; beforeSrc: string } = null;
          if (React.isValidElement(originalNode)) {
            previewImgObj = JSON.parse((originalNode?.props as any)?.src ?? '{}');
          }
          const hasPre = previewImgObj?.beforeSrc?.length > 0;
          const hasNow = previewImgObj?.afterSrc?.length > 0;
          return (
            <div className={cx('preview')}>
              <div className={cx('pre-img-wrapper')}>
                {hasPre ? (
                  <>
                    <img src={previewImgObj.beforeSrc} alt="before" />
                    <div className={cx('tip', 'pre')}>服务前</div>
                  </>
                ) : (
                  <div className={cx('empty', 'before')}>
                    {noBeforeUploadText ? noBeforeUploadText : '服务前动作测试未上传'}
                  </div>
                )}
              </div>
              <div className={cx('now-img-wrapper')}>
                {hasNow ? (
                  <>
                    <img src={previewImgObj.afterSrc} alt="after" />
                    <div className={cx('tip', 'now')}>服务后</div>
                  </>
                ) : (
                  <div className={cx('empty', 'after', { 'no-service': source === 'no-servicing' })}>
                    {noAfterUploadText ? noAfterUploadText : '补充动作复测'}
                  </div>
                )}
              </div>
            </div>
          );
        },
      }}
    >
      {props.children}
    </Image.PreviewGroup>
  ) : (
    props.children
  );
};
